import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })`
    display: flex;
    gap: 5px;
`;

interface ButtonTagType {
    isDeleteButton?: boolean;
}

export const ButtonTag = styled('button', { label: 'ButtonTag' }) <ButtonTagType>`
    user-select: none;
    margin: 5px 0 0 0;
    width: 100%;

    ${({ isDeleteButton }): string => isDeleteButton === true ? `
        background: ${mainColors.grays.gray200};
    ` : ''}
`;


